const RECORD_KEY = "dick-kick.record";

export const getRecord = (): number =>
  Number(localStorage.getItem(RECORD_KEY) ?? 0);

export const setRecord = (score: number): void =>
  localStorage.setItem(RECORD_KEY, String(score));
